export const GooglePlaceDetailType = {
  ADMINISTRATIVE_AREA_LEVEL_1: 'administrative_area_level_1',
  ADMINISTRATIVE_AREA_LEVEL_2: 'administrative_area_level_2',
  ADMINISTRATIVE_AREA_LEVEL_3: 'administrative_area_level_3',
  ADMINISTRATIVE_AREA_LEVEL_4: 'administrative_area_level_4',
  ADMINISTRATIVE_AREA_LEVEL_5: 'administrative_area_level_5',
  COLLOQUIAL_AREA: 'colloquial_area',
  COUNTRY: 'country',
  ESTABLISHMENT: 'establishment',
  FLOOR: 'floor',
  INTERSECTION: 'intersection',
  LANDMARK: 'landmark',
  LOCALITY: 'locality',
  NEIGHBORHOOD: 'neighborhood',
  PLUS_CODE: 'plus_code',
  POLITICAL: 'political',
  POSTAL_CODE: 'postal_code',
  PREMISE: 'premise',
  ROOM: 'room',
  ROUTE: 'route',
  STREET_ADDRESS: 'street_address',
  STREET_NUMBER: 'street_number',
  SUBLOCALITY: 'sublocality',
  SUBPREMISE: 'subpremise'
};
